import React from 'react';
import { MapPin, Clock, CreditCard, Navigation, MessageCircle } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ed1dcb87-1c9b-44b4-b8a7-b978d9d63257/artifacts/eirwjtzy_88.jpeg";

const GOOGLE_MAPS_URL = "https://www.google.com/maps/place/R.+Apol%C3%B4nio+de+Barros,+287+-+S%C3%A3o+Benedito,+CE,+62370-000,+Brasil/@-4.0438858,-40.8671714,17z";
const GOOGLE_MAPS_EMBED = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.5!2d-40.8671714!3d-4.0438858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x794c3c599fd4865%3A0x7ca3cbfb791e9420!2sR.%20Apol%C3%B4nio%20de%20Barros%2C%20287%20-%20S%C3%A3o%20Benedito%2C%20CE%2C%2062370-000!5e0!3m2!1spt-BR!2sbr!4v1706000000000!5m2!1spt-BR!2sbr";

const WHATSAPP_MESSAGE = "Olá! Gostaria de fazer um pedido no Armazém 88.";
const WHATSAPP_URL = `https://wa.me/5588988654624?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// WhatsApp Icon SVG Component
const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white py-12 md:py-16 pb-24 md:pb-16">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Logo & About */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Armazém 88" 
              className="h-24 w-auto object-contain mb-4 rounded-xl"
              style={{ background: 'transparent' }}
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Do Armazém direto para você! Peça pelo WhatsApp e receba rápido na sua casa ou comércio.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FFD700]">Faça seu Pedido</h4>
            <div className="space-y-3">
              <a 
                href={WHATSAPP_URL}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white px-4 py-3 rounded-xl transition-colors font-bold"
                data-testid="footer-whatsapp"
              >
                <WhatsAppIcon className="w-6 h-6" />
                <div>
                  <span className="block text-sm">Clique para pedir</span>
                  <span className="block text-xs opacity-80">(88) 98865-4624</span>
                </div>
              </a>
              <a 
                href={GOOGLE_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-gray-300 hover:text-[#FFD700] transition-colors group"
                data-testid="footer-address"
              >
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="block">R. Apolônio de Barros, 287</span>
                  <span className="block text-sm text-gray-400 group-hover:text-[#FFD700]">São Benedito - CE, 62370-000</span>
                </div>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FFD700]">Horário</h4>
            <div className="flex items-start gap-3 text-gray-300">
              <Clock className="w-5 h-5 mt-0.5" />
              <div>
                <p>Segunda a Sábado</p>
                <p className="text-white font-medium">09:00 - 17:00</p>
              </div>
            </div>
          </div>

          {/* Payment Methods */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FFD700]">Formas de Pagamento</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-gray-300">
                <div className="bg-[#25D366]/20 p-2 rounded-lg">
                  <span className="text-[#25D366] font-bold text-sm">PIX</span>
                </div>
                <div>
                  <p className="text-white font-medium">Chave PIX</p>
                  <p className="text-sm text-gray-400">88 98865-4624</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-gray-300">
                <CreditCard className="w-5 h-5 mt-0.5" />
                <div>
                  <p className="text-white font-medium">Cartões</p>
                  <p className="text-sm text-gray-400">Visa, Master, Elo, Amex</p>
                  <p className="text-sm text-gray-400">Débito e Crédito</p>
                </div>
              </div>
              <p className="text-sm text-gray-400 mt-2">💵 Dinheiro</p>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-10 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <MapPin className="w-6 h-6 text-[#FFD700]" />
              <div>
                <h4 className="text-lg font-bold text-white">Nossa Localização</h4>
                <p className="text-sm text-gray-400">R. Apolônio de Barros, 287 - São Benedito, CE</p>
              </div>
            </div>
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=-4.0438858,-40.8645965`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-[#FFD700] text-black px-6 py-3 rounded-full font-bold hover:bg-[#FFC000] transition-colors"
              data-testid="directions-button"
            >
              <Navigation className="w-5 h-5" />
              Como Chegar
            </a>
          </div>
          
          <div className="rounded-xl overflow-hidden border-2 border-gray-700">
            <iframe
              src={GOOGLE_MAPS_EMBED}
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Armazém 88"
              className="w-full"
            />
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-8 text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} Armazém 88 - Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
};
